module.exports = __webpack_public_path__ + "static/img/new_program_07.52613a4b.jpg";